module.exports = __webpack_public_path__ + "static/media/sv.88ca96e7.svg";